export default function xCTATracker() {
  if (window.location.hostname.includes('referrals.charliehealth') && window.location.search.includes('Twitter')) {
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link || !link.href) return;

      const { pathname, href } = new URL(link.href);

      // Track clicks on specific referral-related links inlcuding old urls
      if (
        pathname === '/referrals' ||
        pathname === '/referral-form' ||
        href === 'https://app.charliehealth.com/referrals/create'
      ) {
        // Get Started CTA click
        twq('event', 'tw-pnn7t-pzw7g');
      } else if (href.startsWith('tel:')) {
        // Phone number CTA click
        twq('event', 'tw-pnn7t-pzw7v');
      }
    });
  }
}
